import React from "react";
import "./CategoryDetailNotaMetodologicaComponent.scss";
import PropTypes from "prop-types";
import { removeTags } from "../../../../../../utils/Constans";

/**
 * @function CategoryDetailNotaMetodologicaComponent test components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
 */
const CategoryDetailNotaMetodologicaComponent = ( { info } ) => {
    const currentCarousel = React.createRef();


    return (
        removeTags(info) ? ( <div className="CategoryDetailNotaMetodologicaComponent">
            <div  role="contentinfo" tabIndex="0" aria-label={"Nota metodologica"}  className="CategoryDetailNotaMetodologicaComponent__title">Nota metodologica</div>
            <span role="contentinfo" tabIndex="0" aria-label={removeTags(info)} className="fw-600" dangerouslySetInnerHTML={ { __html: info } }></span>
        </div> ) : null

    );
};

CategoryDetailNotaMetodologicaComponent.propTypes = {
    info: PropTypes.string.isRequired,
};

CategoryDetailNotaMetodologicaComponent.defaultProps = {
    info: "",
};

export default CategoryDetailNotaMetodologicaComponent;